import apiFetech from "../configs/axios";
import { API_POINT_DOMAIN } from "../constants/urls";

export class MealServices {
  /**
   * ### Get  Meals Where Category ID
   * @param {categoryID} Object
   * CategoryID and Page Number (Paginate)
   * @returns Promise
   */
  static getWhereCategoryID({ categoryID, cityID }) {
    var config = {
      method: "get",
      url: `/city/${cityID}/category/${categoryID}/meal`
    };
    return apiFetech(config);
  }
  /**
   * ## Get Next Page
   * @param {String} url
   * @returns {Promise}
   */
  static getWhereCategoryIDPaginate({ url }) {
    var config = {
      method: "get",
      url: `${url.replace(`${API_POINT_DOMAIN}`, "")}`
    };
    return apiFetech(config);
  }

  /**
   * ## Add Meal Rating
   * @param {Object} data
   * @param {Int} mealID
   * @param {String} userToken
   * @returns {Promise} Promise
   */
  static addMealRating({ data, mealID, userToken }) {
    var config = {
      method: "post",
      url: `order/rateMeal/${mealID}`,
      headers: {
        Authorization: `Bearer ${userToken}`
      },
      data: data
    };
    return apiFetech(config);
  }

  static addProviderRating({ data, providerID, userToken }) {
    var config = {
      method: "post",
      url: `order/rateProvider/${providerID}`,
      headers: {
        Authorization: `Bearer ${userToken}`
      },
      data: data
    };
    return apiFetech(config);
  }

  static getSizes({ id }) {
    var config = {
      method: "get",
      url: `size/${id}`
    };
    return apiFetech(config);
  }

  /**
   * ## Get Meal By ID
   * @param {Int} mealID
   */
  static getWhereID(mealID) {
    var config = {
      method: "get",
      url: `meal/show/${mealID}`
    };
    return apiFetech(config);
  }

  static getMealTypes() {
    var config = {
      method: "get",
      url: `type_meal`
    };
    return apiFetech(config);
  }

  static getMealsByProviderID({ providerID }) {
    var config = {
      method: "get",
      url: `meal/provider/${providerID}`
    };
    return apiFetech(config);
  }

  static getNextPage({ url }) {
    var config = {
      method: "get",
      url: `${url}`
    };
    return apiFetech(config);
  }

  // Get Search Meals by name
  static searchMeals({ name, city_id = 0, categoryID = 0 }) {
    var config = {
      method: "GET",
      url: `search/city_id/${city_id}/meal?name=${name}&category_id=${categoryID}`
    };
    return apiFetech(config);
  }

  // Get Meals By Filtering
  static getFilterMeals({ filter,city_id }) {
    var config = {
      method: "GET",
      url: `search/city_id/${city_id}/meals${filter}`
    };
    
    return apiFetech(config);
  }
}
